import { Row, Col, Space, Form, Input, Switch, Divider } from "antd"
import { useEffect } from "react"
import PercentInput from "./PercentInput"
import { Budget, fromViewModel, toViewModel, ViewModel } from './budgetModel'


const SwitchWithLabel = (props: { value?: boolean, onChange?: (value: boolean) => void }) => {
  return <Space>
    <Switch {...props} />
    This is the default budget
  </Space>
}

const ClassRow = ({ name, classKey }: { name: string, classKey: string }) => {
  return <Row gutter={8}>
    <Col span={8}>{name}</Col>
    <Col span={8}>
      <Form.Item name={[classKey, 'overhead']}>
        <PercentInput />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item name={[classKey, 'profit']}>
        <PercentInput max={0.9999} />
      </Form.Item>
    </Col>
    <Form.Item name={[classKey, 'class']} hidden><Input type="hidden" /></Form.Item>
  </Row>
}

type BudgetProps = {
  budgets?: Budget[]
  saveCounter?: number
  onChange?: (budgets: Budget[]) => void
}

const BudgetForm = ({ budgets, saveCounter, onChange }: BudgetProps) => {
  const handleChange = (value: ViewModel) => {
    if (!budgets) {
      return
    }

    onChange?.(fromViewModel(budgets, value))
  }

  const [form] = Form.useForm()
  useEffect(() => {
    form.resetFields()
  }, [budgets?.[0].year, saveCounter])


  return <Space direction="vertical">
    <Form initialValues={budgets && toViewModel(budgets)} layout="vertical" onValuesChange={(_, value) => handleChange(value)} form={form}>
      {budgets && <>
        <Form.Item label="Name" name="name">
          <Input maxLength={35} />
        </Form.Item>
        <Form.Item name="isDefault">
          <SwitchWithLabel />
        </Form.Item>
        <Form.Item label="Tax Rate" name="taxRate">
          <PercentInput />
        </Form.Item>
        <Form.Item name="year" hidden><Input type="hidden" /></Form.Item>

        <Divider />
        <Row gutter={8} style={{ fontWeight: 'bold', marginBottom: 8 }}>
          <Col span={8}>Class</Col>
          <Col span={8}>Overhead %</Col>
          <Col span={8}>Profit Margin</Col>
        </Row>

        <ClassRow name="Labor" classKey="labor" />
        <ClassRow name="Equipment" classKey="equipment" />
        <ClassRow name="Materials" classKey="materials" />
        <ClassRow name="Subcontracting" classKey="subcontracting" />
        <ClassRow name="Other" classKey="other" />
      </>}
    </Form>
  </Space>
}

export default BudgetForm
